<section class="container pt-2">
  <div class="row">
    <!-- Account details -->
    <div class="col-md-8 offset-lg-1 pb-5 mb-2 mb-lg-4 pt-md-5 mt-n3 mt-md-0">
      <router-outlet> </router-outlet>
    </div>
  </div>
</section>
